import { FC, useEffect, useState } from 'react'
import { Box, CircularProgress, Grid, TextField } from 'src/components/UI'
import Modal from 'src/components/UI/CustomUI/molecules/Modal'
import Estimator from './Estimator'
import { AssignModalProps } from './types'

import { useDispatch, useSelector } from 'react-redux'
import { estimateActions, estimatesActions } from 'src/ducks/actions'
import estimateSelectionActions from 'src/ducks/estimateSelection/actions'
import { getAssignMultipleLoading } from 'src/ducks/estimateSelection/selector'
import useStyles from './styles'

const AssignModal: FC<AssignModalProps> = ({
  assigners,
  open,
  setOpen,
  handleClose,
  estimate,
  estimateMultiple,
  onAssignComplete,
}) => {
  const styles = useStyles()

  const dispatch = useDispatch()

  const [search, setSearch] = useState<string>('')
  const [loading, setLoading] = useState<boolean>(false)
  const assignMultipleLoading = useSelector(getAssignMultipleLoading)

  useEffect(() => {
    if (!estimateMultiple) {
      setLoading(true)
      dispatch(
        estimateActions.fetchEstimate(estimate.id, (succ) => {
          setLoading(false)
        })
      )
    }
  }, [dispatch, estimate.id, estimateMultiple])

  const assignEstimatorMultiple = (estimatorId: string) => {
    dispatch(estimateSelectionActions.setAssignMultipleLoading(true))

    dispatch(estimatesActions.assignMultipleEstimates({ estimateIds: estimateMultiple || [], estimatorId }, (succ) => {
      if (succ) {
        dispatch(estimateSelectionActions.setAssignMultipleLoading(false))
        // trigger refreshing
        onAssignComplete && onAssignComplete()
        handleClose()
      }
    }))

  }

  const assignEstimator = (estimatorId: string) => {
    setLoading(true)

    dispatch(estimatesActions.updateEstimate({ id: estimate.id, estimatorId }, (succ) => {
      if (succ) {
        // trigger refreshing
        onAssignComplete && onAssignComplete()
      }

      setLoading(false)
      handleClose()
    }))
  }

  return (
    <Modal
      open={open}
      setOpen={() => setOpen(false)}
      title={estimateMultiple ? `Assign ${estimateMultiple.length} Estimates to Estimator` : "Assign to Estimator"}
      onClose={handleClose}
    >
      {loading || assignMultipleLoading ? (
        <Grid container justifyContent='center'><CircularProgress /></Grid>
      ) : (
        <>
          <TextField
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="Search..."
            className={styles.searchBox}
          />
          <Box className={styles.container}>
            <Grid container spacing={1}>
              {assigners
                .filter((estimator) =>
                  `${estimator.firstName} ${estimator.lastName}`
                    .toLowerCase()
                    .includes(search.toLowerCase())
                )
                .map((estimator) => (
                  <Estimator
                    key={estimator.id}
                    estimator={estimator}
                    assignEstimator={estimateMultiple ? assignEstimatorMultiple : assignEstimator}
                  />
                ))}
            </Grid>
          </Box>
        </>
      )}
    </Modal>
  )
}

export default AssignModal
